import { useTranslation } from "react-i18next";

import type { WarrantyFlowCtaPayload } from "@/api/rest/services/chatService.ts";
import Button from "@/components/common/Button.tsx";

export const isChatInputDisabled = ({
  showEscalatePrompt,
  showEscalationForm,
}: {
  showEscalatePrompt: boolean;
  showEscalationForm: boolean;
}) => showEscalatePrompt || showEscalationForm;

export const createWarrantyCtaClickHandler =
  (closeChat: () => void, navigate: (targetPath: string) => void) => (targetPath: string) => {
    closeChat();
    navigate(targetPath);
  };

export function WarrantyFlowCta({
  cta,
  onOpenWarrantyFlow,
}: {
  cta: WarrantyFlowCtaPayload;
  onOpenWarrantyFlow: (targetPath: string) => void;
}) {
  const { t } = useTranslation();

  return (
    <div className="mt-3 rounded-md border border-orange-200 bg-orange-50 p-3 text-sm text-gray-700">
      <div className="font-medium text-gray-900">{t("chat.warrantyCta.supporting")}</div>
      <Button
        type="button"
        size="sm"
        className="mt-2"
        onClick={() => {
          onOpenWarrantyFlow(cta.targetPath);
        }}
      >
        {t("chat.warrantyCta.primary")}
      </Button>
    </div>
  );
}
